export const BAR_STYLES: React.CSSProperties = {
    zIndex: 2,
    padding: '1rem 1rem 1rem 2rem',
    background: '#ffffff',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
};

export const BORDER_LEFT = {
    borderLeft: '1px solid lightgray !important',
};

export const PADDING_TITLE = {
    padding: '3em 0 2em 0',
};
